// ------------------------------------- NO TENANT AUTH ROUTE APIS -----------------------------------
export const SEND_TENANT_USER_ACCOUNT_OTP_API = "/send_otp_to_tenant_user_account";
export const VERIFY_TENANT_USER_ACCOUNT_OTP_API = "/verify_tenant_user_account_login_otp";
export const SEND_SALES_REP_USER_ACCOUNT_OTP_API = "/send_otp_to_sales_rep_account";
export const VERIFY_SALES_REP_USER_ACCOUNT_OTP_API = "/verify_sales_rep_user_account_login_otp";


// -------------------------------------- AUTH TENANTS LIST -------------------------------------
// Auth
export const AUTH_RESIGN_TENANT_API = "/auth/resign_in_send_otp_to_tenant_user_account";



// Create
export const ADMIN_CREATE_TENANT_API = "/create/admin_create_tenant";
export const CREATE_PRODUCT_TYPES_API = "/product_types/create_product_type";
export const CREATE_PRODUCT_API = "/product/create_product";
export const CREATE_WAREHOUSE_SITE_API = "/warehouse_site/add_warehouse_site";
export const ADD_TENENT_SALES_REP_API = "/sales_reps/create_tenants_sales_rep";
export const SALES_REP_CREATE_ORDER_API = "/sales_rep/orders/create_order";
export const ADD_EMPLOYEE_TO_TENANT_API = "/profile/add_employee_to_tenant";
export const ADD_PRODUCT_TO_EXISTING_ORDER_API = "/sales_rep/orders/add_products_to_existing_order";
export const CREATE_TENANT_ORDER_DISPATCH_API = "/dispatches/create_tenant_order_dispatch";
export const ADD_TENANT_GOODS_RECEIVED_API = "/goods_received/add_tenant_goods_received";
export const ADMIN_ADD_EMPLOYEE_TO_TENANT_API = "/profiles/admin_add_employee_to_tenant";
export const ADD_STOCK_TO_PRODUCT_API = "/warehouse_inventory/add_stock_to_product";
export const TENANT_BACK_DATE_ORDER_API = "/orders/tenant_back_date_order";

// Stock Take Create
export const TENANT_TENANT_CREATE_STOCK_TAKE_API = "/stock_take/tenant_create_stock_take";

// Agency Create
export const ADD_TENANT_AGENCY_API = "/agencies/add_tenant_agency";

// Agency Sales Rep Create
export const TENANT_CREATE_AGENCY_SALES_REP_API = "/agency_sales_rep/tenant_add_sales_rep_to_agency";

// Products Create
export const UPDATE_TENANT_PRODUCT_PRICE_API = "/product/update_tenant_product_price";

// Budget Allocation Add
export const ADD_TENANT_BUDGET_ALLOCATION_API = "/budget_allocations/tenant_add_budget_allocation";
export const ADD_SALES_REP_TO_BUDGET_ALLOCATION_API = "/budget_allocations/add_sales_rep_allocation";



// Retrieve
export const RETRIEVE_TENANTS_LIST_API = "/tenants/list";
export const RETRIEVE_TENANT_PRODUCT_TYPES_API = "/product_types/retrieve_tenant_product_types";
export const RETRIEVE_TENANT_PRODUCTS_API = "/product/retrieve_tenant_products";
export const RETRIEVE_TENANT_PRODUCT_TYPE_BY_STATUS_API = "/product_types/retrieve_product_types_by_status";
export const RETRIEVE_TENANT_WAREHOUSE_SITES_API = "/warehouse_sites/retreive_tenant_warehouse_sites";
export const RETRIEVE_TENANT_AUDIT_TRAILS_SITES_API = "/admin/retrieve_tenant_audit_trails";
export const RETRIEVE_TENANT_PROFILES_LIST_API = "/profiles/retrieve_tenant_profiles_list";
export const RETRIEVE_TENANT_PROFILE_DETAILS_API = "/profiles/retrieve_tenant_profile_details";
export const RETRIEVE_TENANT_PROFILE_ROLES_API = "/profiles/retrieve_tenant_profiles_roles";
export const RETRIEVE_SPECIFIC_TENANT_PRODUCT_DETAILS_API = "/products/retrieve_specific_tenant_product_details";
export const RETRIEVE_ADD_STOCK_DETAILS_API = "/products/retrieve_adjust_stock_data";
export const RETRIEVE_TENANT_SALES_REPS_API = "/sales_reps/retreive_tenant_sales_rep_list";
export const RETRIEVE_BRANDS_LIST_API = "/product/retrieve_grouped_tenant_categories";
export const RETRIEVE_SALES_REP_ALLOWED_PRODUCTS_LIST_API = "/sales_rep/retrieve_active_products_restricted_list";
export const RETRIEVE_SPECIFIC_SALES_REP_ALLOWED_PRODUCTS_LIST_API = "/sales_rep/retrieve_specific_active_products_restricted_list";
export const RETRIEVE_SPECIFIC_SALES_REP_PENDING_SUBMISSION_CART_LIST_API = "/sales_rep/orders/retrieve_sales_rep_pending_submission_cart_list";
export const RETRIEVE_TENANT_ORDERS_LIST_API = "/orders/retrieve_tenant_orders_list";
export const RETRIEVE_SALES_REP_TENANT_ORDERS_LIST_API = "/sales_rep/orders/retrieve_specific_sales_rep_order_list";
export const RETRIEVE_SPECIFIC_SALES_REP_TENANT_ORDER_API = "/sales_rep/orders/retrieve_specific_sales_rep_order";
export const TENANT_RETRIEVE_SPECIFIC_SALES_REP_TENANT_ORDER_API = "/orders/tenant_retrieve_specific_sales_rep_order_details";
export const ADMIN_RETRIEVE_TENANT_DETAILS_API = "/tenants/admin_retrieve_specific_tenant_details";
export const RETRIEVE_SPECIFIC_TENANT_DISPATCH_DETAILS_API = "/dispatches/retrieve_specific_tenant_dispatch_details";
export const RETRIEVE_SPECIFIC_SALES_REP_DISPATCH_DETAILS_API = "/dispatches/retrieve_specific_sales_rep_dispatch_details";
export const SALES_REP_CONFIRM_DISPATCH_DELIVERY_API = "/dispatches/sales_rep_confirm_dispatch_delivery";
export const RETRIEVE_TENANT_GOODS_RECEIVED_API = "/goods_received/retrieve_tenant_goods_received";
export const RETRIEVE_SPECIFIC_TENANT_GOODS_RECEIVED_DETAILS_API = "/goods_received/retrieve_specific_tenant_goods_received_details";
export const RETRIEVE_TENANT_PRODUCTS_BY_STATUS_API = "/products/retrieve_tenant_products_by_status";
export const RETRIEVE_TENANT_WAREHOUSE_SITES_BY_STATUS_API = "/warehouse_sites/retrieve_tenant_warehouse_sites_by_status";
export const ADMIN_RETRIEVE_TENANT_EMPLOYEES_LIST_API = "/profiles/admin_retrieve_tenant_employees";
export const ADMIN_RETRIEVE_TENANT_PROFILE_ROLES_API = "/profiles/admin_retrieve_tenant_profiles_roles";
export const RETRIEVE_TENANT_DASHBOARD_DATA_API = "/tenant/retrieve_tenant_dashboard_data";
export const RETRIEVE_TENANT_SALES_REP_BY_STATUS_API = "/sales_reps/retrieve_tenant_sales_rep_by_status";
export const RETRIEVE_TENANT_BACK_DATE_PRODUCT_INFO_API = "/products/tenant_retrieve_back_date_product_information";

// Stock Take Retrieve
export const RETRIEVE_TENANT_STOCK_TAKE_LIST_API = "/stock_take/retrieve_tenant_stock_take_list";
export const RETRIEVE_TENANT_STOCK_TAKE_STARTING_BALANCE_API = "/stock_take/retrieve_warehouse_stock_take_starting_balance";
export const RETRIEVE_TENANT_STOCK_TAKE_DETAILS_API = "/stock_take/retrieve_tenant_stock_take_detatils";
export const RETRIEVE_TENANT_STOCK_TAKE_PREVIEW_DETAILS_API = "/stock_take/preview_stock_take_data";

// Warehouse Inventory Retrieve
export const RETRIEVE_TENANT_SPECIFIC_PRODUCT_COLOR_SIZE_DETAILS_API = "/warehouse_inventory/retrieve_tenant_specific_product_color_size_details";
export const RETRIEVE_TENANT_WAREHOUSE_INVENTORY_ANALYTICS_API = "/warehouse_inventory/retrieve_tenant_warehouse_inventory_analytics";
export const RETRIEVE_TENANT_STOCK_AGE_ANALYSIS_SUMMARY_API = "/warehouse_inventory/retrieve_tenant_stock_age_analysis_summary";
export const RETRIEVE_TENANT_PRODUCT_CATEGORY_STOCK_AGE_ANALYSIS_DATA_API = "/warehouse_inventory/tenant_retrieve_product_category_stock_age_analysis_data";
export const RETRIEVE_TENANT_SPECIFIC_PRODUCT_CATEGORY_STOCK_AGE_ANALYSIS_DATA_API = "/warehouse_inventory/tenant_retrieve_specific_product_category_stock_age_analysis_data";
export const RETRIEVE_TENANT_PRODUCT_STOCK_AGE_ANALYSIS_BREAKDOWN_API = "/warehouse_inventory/tenant_retrieve_product_stock_age_analysis_breakdown";
export const RETRIEVE_TENANT_GOODS_RECEIVED_LIST_API = "/warehouse_inventory/tenant_retrieve_goods_issued_list";

// Setting

// Orders
export const SALES_REP_APPROVER_RETRIEVE_ORDER_LIST_API = "/sales_rep/orders/sales_rep_approver_retrieve_order_list";
export const SALES_REP_APPROVER_RETRIEVE_SPECIFIC_ORDER_API = "/sales_rep/orders/sales_rep_approver_retrieve_specific_order";

// Agency Retrieve
export const RETRIEVE_TENANT_AGENCIES_API = "/agencies/retrieve_tenant_agencies";
export const RETRIEVE_TENANT_AGENCY_DETAILS_API = "/agencies/retrieve_tenant_agency_details";
export const RETRIEVE_TENANT_AGENCY_MAIN_SALES_REP_DETAILS_API = "/agencies/retrieve_tenant_agency_main_sales_rep";
export const RETRIEVE_TENANT_AGENCY_APPROVERS_DETAILS_API = "/agencies/retrieve_tenant_agency_order_approvers";
export const RETRIEVE_TENANT_AGENCY_SALES_REP_DETAILS_API = "/agencies/retreive_agency_sales_rep_details";
export const RETRIEVE_TENANT_AGENCY_SALES_REP_APPROVAL_SETTINGS_API = "/agencies/retrieve_agency_sales_rep_approval_settings";


// Products Retrieve
export const RETRIEVE_TENANT_PRODUCT_PRICING_DETAILS_API = "/products/retrieve_tenant_product_pricing_details";

// Budget Allocation Retrieve
export const RETRIVE_TENANT_BUDGET_ALLOCATIONS_API = "/budget_allocations/retrieve_tenant_budget_allocations";
export const RETRIVE_TENANT_ADD_BUDGET_ALLOCATION_DATA_API = "/budget_allocations/retrieve_tenant_add_budget_allocation_data";
export const RETRIVE_TENANT_BUDGET_ALLOCATION_DETAILS_API = "/budget_allocations/tenant_retrieve_budget_allocation_details";
export const RETRIVE_SPECIFIC_ALLOCATIONS_FOR_BUDGET_API = "/budget_allocations/retrieve_specific_allocations_for_budget";
export const RETRIVE_TENANT_ADD_ALLOCATION_DATA_API = "/budget_allocations/retrieve_add_allocation_data";


// Prodcuts Retrieve 
export const RETRIEVE_TENANT_PRODUCTS_ANALYTICS_API = "/products/retrieve_tenant_product_analytics";

// Orders Retireve /orders/
export const RETRIEVE_TENANT_ORDERS_ANALYTICS_API = "/orders/retrieve_tenant_order_analytics";

// Stock Levels
export const RETRIEVE_TENANT_STOCK_LEVELS_API = "/stock_levels/tenant_retrieve_stock_levels_summary";


// Update
export const UPDATE_TENANT_PROFILE_ROLE_API = "/profiles/toggle_tenant_profile_role";
export const UPDATE_TENANT_ORDER_STATUS_API = "/orders/tenant_update_order_status";
export const ADMIN_UPDATE_TENANT_LOGO_API = "/tenants/admin_update_tenant_logo";
export const ADMIN_UPDATE_TENANT_EMAIL_CREDENTIALS_API = "/tenants/admin_update_tenant_email_provider";
export const ADMIN_UPDATE_TENANT_SMS_CREDENTIALS_API = "/tenants/admin_update_tenant_sms_provider";
export const TENANT_ADD_PRODUCTS_AND_COMPLETE_DISPATCH_API = "/dispatches/tenant_add_products_and_complete_dispatch";
export const TENANT_ADD_PRODUCTS_AND_COMPLETE_GOODS_RECEIVED_API = "/goods_received/tenant_add_products_and_complete_goods_received";
export const SALES_REP_UPDATE_ORDER_STATUS_API = "/orders/sales_rep_update_order_status";
export const TENANT_SUBMIT_BACKDATED_ORDER_ITEMS_API = "/products/tenant_submit_backdated_order_items";
export const TENANT_CONFIRMS_BACKDATED_DISPATCH_DELIVERY_API = "/dispatches/tenant_confirms_backdated_order_delivery";

// Stock Take Update
export const TENANT_SUBMIT_STOCK_TAKE_REPORT_API = "/stock_take/tenant_submit_stock_take_report";
export const TENANT_UPDATE_THEORETICAL_STOCK_TO_PHYSICAL_STOCK_BALANCE_API = "/stock_take/tenant_update_theoretical_stock_to_physical_stock_balance";
export const TENANT_UPDATE_STOCK_TAKE_PRODUCTS_API = "/stock_take/tenant_update_stock_take_products";

// Products Update
export const TENANT_UPDATE_PRODUCT_IMAGE_API = "/products/tenant_update_product_image";
export const TENANT_UPDATE_PRODUCT_DETAILS_API = "/products/update_tenant_product_details";
export const TENANT_TOGGLE_PRODUCT_VIEWABLE_ON_WEBSTORE_API = "/products/tenant_toggle_products_viewable_on_webstore";




// Orders Update
export const SALES_REP_UPDATE_ORDER_UNITS_API = "/sales_rep/orders/sales_rep_approver_update_order_units";
export const SALES_REP_SECOND_APPORVER_UPDATE_ORDER_STATUS_API = "/sales_rep/orders/sales_rep_second_approver_update_order_status";
export const SALES_REP_FIRST_APPORVER_UPDATE_ORDER_STATUS_API = "/sales_rep/orders/sales_rep_first_approver_update_order_status";




// Update Agency
export const TENANT_UPDATE_AGENCY_MAIN_SALES_REP_API = "/agencies/tenant_update_agency_main_sales_rep";
export const TENANT_UPDATE_AGENCY_ORDER_APPROVERS_API = "/agencies/tenant_update_agency_order_approvers";
export const TENANT_UPDATE_AGENCY_SALES_REP_ORDER_APPROVAL_SETTINGS_API = "/agencies/tenant_update_agency_sales_rep_approval_settings";

// Delete 

// Delete Order Item
export const SALES_REP_DELETE_ORDER_ITEM_API = "/sales_rep/orders/delete_order_item_from_order";


// Delete Settings
export const DELETE_EMPLOYEE_FROM_READY_FOR_DISPATCH_NOTIFICATIONS_API = "/settings/delete_employee_from_ready_for_dispatch_notiications";
export const DELETE_SYSTEM_BRAND_API = "/settings/delete_system_brand";

// -------------------------------------------------- Settings --------------------------------------------------------
// Retrieve
export const RETRIEVE_SPECIFIC_TENANT_SETTINGS_API = "/settings/retrieve_tenant_settings";
export const RETRIEVE_TENANT_APPROVERS_AND_SALES_REP_API = "/settings/retrieve_tenant_approvers_and_sales_reps";
export const RETRIEVE_TENANT_READY_FOR_DISPATCH_SETTINGS_API = "/settings/retireve_ready_for_dispatch_setting";
export const RETRIEVE_TENANT_BRANDS_SETTINGS_API = "/settings/retrieve_tenant_brands_settings";
export const RETRIEVE_TENANT_SYSTEM_BRANDS_API = "/settings/retrieve_tenant_system_brands";
export const RETRIEVE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_API = "/settings/retrieve_tenant_stock_movement_suspension_settings";
export const RETRIEVE_TENANT_PROMOTIONS_USSD_CODE_SETTINGS_API = "/promotions/settings/tenant_retrieve_promotions_ussd_codes_settings";


// Update
export const TENANT_UPDATE_ORDER_APPROVERS_API = "/settings/tenant_update_order_approvers";
export const TENANT_UPDATE_READY_FOR_DISPATCH_SETTINGS_API = "/settings/tenant_add_ready_for_dispatch";
export const UPDATE_TENANT_LOGO_API = "/settings/handle_tenant_logo_update";
export const UPDATE_TENANT_EMAIL_CREDENTIALS_API = "/settings/update_tenant_email_address";
export const UPDATE_TENANT_SMS_CREDENTIALS_API = "/settings/update_tenant_sms_provider";
export const UPDATE_TENANT_BRAND_SETTINGS_API = "/settings/tenant_add_brand_settings";
export const UPDATE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_API = "/settings/update_tenant_stock_movement_suspension_settings";
export const TENANT_PROMOTIONS_CREATE_USSD_CODE_API = "/promotions/settings/tenant_promotions_create_ussd_code";
export const TENANT_PROMOTIONS_UPDATE_USSD_CODE_API = "/promotions/settings/tenant_update_ussd_code";


// -------------------------------------------------- Sales Reps --------------------------------------------------------
// Get
export const RETRIEVE_SPECIFIC_TENANT_SALES_REP_DETAILS_API = "/sales_reps/tenant_retrieve_specific_sales_rep_details";
export const RETRIEVE_SPECIFIC_TENANT_SALES_REP_ALLOWED_BRAND_DETAILS_API = "/sales_reps/tenant_retrieve_sales_rep_allowed_brand_details";

// Post
export const TENANT_TOGGLE_SALES_REP_ALLOWED_BRAND_API = "/sales_reps/tenant_toggle_sales_rep_allowed_brand";
export const TENANT_TOGGLE_SALES_REP_ALLOWED_BRAND_PRODUCT_TYPE_API = "/sales_reps/tenant_toggle_sales_rep_allowed_brand_product_type";



// -------------------------------------------------- Budget Allocations --------------------------------------------------------
// Get
export const RETRIEVE_TENANT_SPECIFIC_SALES_REP_BUDGET_ALLOCATION_DETAILS_API = "/budget_allocations/retrieve_tenant_specific_sales_rep_budget_allocation_details";

// Post
export const TENANT_UPDATE_SALES_REP_ALLOCATED_BUDGET_VALUE_API = "/budget_allocations/tenant_update_sales_rep_allocated_budget_value";


// -------------------------------------------------- Orders --------------------------------------------------------
// GET
export const TENANT_RETRIEVE_ORDER_REPORT_DATA_BY_DATE_API = "/orders/tenant_retrieve_order_report_data_by_date";
export const TENANT_RETRIEVE_SALES_REP_ORDER_ITEMS_BY_DATE_API = "/orders/tenant_retrieve_sales_rep_order_items_by_date_range";
export const TENANT_RETRIEVE_SALES_REP_ORDERS_BY_DATE_API = "/orders/tenant_retrive_sales_rep_orders_by_date_range";

// POST
export const TENANT_CANCEL_ORDER_ITEM_API = "/orders/tenant_cancel_order_item_from_order";
export const TENANT_EDIT_ORDER_ITEM_API = "/orders/tenant_edit_order_item_units";

// Admin
// -------------------------------------------------- Tenant --------------------------------------------------------
// GET
export const ADMIN_RETRIEVE_SPECIFIC_TENANT_MODULE_LIST_API = "/tenants/admin_retrieve_specific_tenant_module_list";
export const ADMIN_RETRIEVE_ADD_TENANT_TO_MODULE_DATA_API = "/tenants/admin_retrieve_add_tenant_to_module_data";
export const ADMIN_RETRIEVE_TENANT_MODULE_EMPLOYEES_API = "/tenants/admin_retrieve_tenant_module_employees";
export const ADMIN_RETRIEVE_EMPLOYEES_NOT_IN_TENANT_MODULE_DATA_API = "/tenants/admin_retrieve_employees_not_in_tenant_module_data";
export const ADMIN_RETRIEVE_SMS_PORTAL_SETTINGS_API = "/tenants/admin_retrieve_tenant_sms_portal_settings";



// POST
export const ADMIN_ADD_MODULE_TO_TENANT_API = "/tenants/admin_add_module_to_tenant";
export const ADMIN_ADD_EMPLOYEE_TO_TENANT_MODULE_API = "/tenants/admin_add_employee_to_tenant_module";

// -------------------------------------------------- Promotions --------------------------------------------------------
// GET
export const TENANT_RETRIEVE_PRMOTIONS_LIST_API = "/promotions/tenant_retrieve_promotions_list";
export const TENANT_RETRIEVE_CREATE_PROMOTION_DATA_API = "/promotions/tenant_retrieve_create_promotion_data";
export const TENANT_RETRIEVE_PROMOTION_DETAILS_API = "/promotions/tenant_retrieve_promotion_details";
export const TENANT_RETRIEVE_CREATE_PROMOTION_DRAW_DATA_API = "/promotions/tenant_retrieve_create_promotion_draw_data";
export const TENANT_RETRIEVE_PROMOTION_DRAW_DETAILS_API = "/promotions/tenant_retrieve_promotion_draw_details";
export const TENANT_RETRIEVE_PROMOTION_DASHBOARD_DATA_API = "/promotions/tenant_retrieve_promotions_module_dashboard_data";
export const TENANT_RETRIEVE_PARTICIPANTS_API = "/promotions/tenant_retrieve_participants";
export const TENANT_RETRIEVE_PROMOTION_MODULE_EMPLOYEES_API = "/promotions/teanant_retrieve_promotion_module_employees";
export const TENANT_RETRIEVE_PROMOTION_PROFILE_ROLES_API = "/promotions/retrieve_tenant_promotion_profiles_roles";
export const TENANT_RETRIEVE_PROMOTION_PROFILE_DETAILS_API = "/profiles/retrieve_tenant_promotion_profile_details";
export const TENANT_RETRIEVE_PROMOTIONS_AUDIT_TRAILS_API = "/promotions/retrieve_tenant_promotions_audit_trails";
export const TENANT_RETRIEVE_CONTINUE_PROMOTION_DRAW_DATA_API = "/promotions/tenant_retrieve_continue_promotion_draw_data";
export const TENANT_SELECT_DRAW_WINNER_DATA_API = "/promotions/tenant_select_draw_winner";
export const TENANT_RETRIEVE_CODE_LOOK_UP_INTEGRATION_SETTINGS_API = "/promotions/settings/retrieve_code_look_up_integration_settings";
export const TENANT_RETRIEVE_PROMOTION_MENU_IDENTIFIER_SETTINGS_API = "/promotions/settings/tenant_retrieve_promotion_menu_identifier_settings";
export const TENANT_RETRIEVE_PROMOTION_RESTRICTED_NUMBERS_SETTINGS_API = "/promotions/settings/tenant_retrive_promotion_restricted_numbers_settings";
export const TENANT_RETRIEVE_PROMOTION_MESSAGE_SETTINGS_API = "/promotions/settings/tenant_retrieve_promotion_messages_settings";



// POST
export const TENANT_CREATE_PROMOTION_API = "/promotions/tenant_create_promotion";
export const TENANT_CREATE_PROMOTION_DRAW_DATA_API = "/promotions/tenant_create_promotion_draw_data";
export const TENANT_BEGIN_PROMOTION_DRAW_API = "/promotions/tenant_begin_promotion_draw";
export const TENANT_ADD_EMPLOYEES_TO_TENANT_PROMOTION_MODULE_API = "/promotions/add_employee_to_tenant_promotion_module";
export const TENANT_TOGGLE_PROMOTION_PROFILE_ROLE_API = "/promotions/toggle_tenant_promotion_profile_role";
export const TENANT_UPDATE_PROMOTION_CODE_LOOKUP_INTEGRATION_SETTINGS_API = "/promotions/settings/tenant_update_promotion_code_lookup_integration_settings";
export const TENANT_UPDATE_PROMOTION_MENU_IDENTIFIER_SETTINGS_API = "/promotions/settings/tenant_update_promotion_menu_identifier_settings";
export const TENANT_ADD_PROMOTION_RESTRICTED_NUMBERS_SETTINGS_API = "/promotions/settings/tenant_add_promotion_restricted_numbers_settings";
export const TENANT_DELETE_PROMOTION_RESTRICTED_NUMBERS_SETTINGS_API = "/promotions/settings/tenant_delete_promotion_restricted_number_settings";
export const TENANT_ADD_PROMOTION_MESSAGE_SETTINGS_API = "/promotions/settings/tenant_add_promotion_message_settings";
export const TENANT_DELETE_PROMOTION_MESSAGE_SETTINGS_API = "/promotions/settings/tenant_delete_promotion_message";

